import React from 'react';
import PropTypes from 'prop-types';
import { Button, useMediaQuery, CircularProgress } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';

// Styled Button com padrão FIXO do cabeçalho
const StyledStandardButton = styled(Button)(({ theme, variant: buttonVariant }) => ({
  // PADRÃO FIXO: borderRadius 5px SEMPRE
  borderRadius: '5px !important',
  
  // PADRÃO FIXO: Tamanho do cabeçalho
  padding: theme.spacing(1.5, 4),
  fontSize: '1rem',
  fontWeight: 600,
  textTransform: 'none',
  minHeight: 44, // Altura fixa do cabeçalho
  
  // Shadow apenas para contained
  boxShadow: buttonVariant === 'contained' 
    ? '0 4px 12px rgba(0, 0, 0, 0.15)' 
    : 'none',
    
  '&:hover': {
    transform: 'translateY(-1px)',
    boxShadow: buttonVariant === 'contained' 
      ? '0 6px 16px rgba(0, 0, 0, 0.2)' 
      : 'none',
  },
  
  '&:disabled': {
    transform: 'none',
    boxShadow: 'none',
  },
  
  transition: 'all 0.2s ease',
  
  // Mobile: Mantém o mesmo padrão mas ajusta padding
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1, 2.5),
    fontSize: '0.875rem',
    minHeight: 36, // Mesmo tamanho em mobile
    borderRadius: '5px !important', // Força borderRadius em mobile também
  }
}));


// StandardButton com tamanho FIXO do cabeçalho
const StandardButton = ({
  children,
  variant = 'contained',
  color = 'primary',
  size = 'medium', // Ignorado - sempre usa tamanho padrão
  startIcon,
  endIcon,
  fullWidth = false,
  disabled = false,
  loading = false,
  onClick,
  sx = {},
  ...props
}) => {
  const theme = useTheme();

  return (
    <StyledStandardButton
      variant={variant}
      color={color}
      startIcon={loading ? <CircularProgress size={16} color="inherit" /> : startIcon}
      endIcon={loading ? null : endIcon}
      fullWidth={fullWidth}
      disabled={disabled || loading}
      onClick={onClick}
      sx={{
        // FORÇA borderRadius 5px sempre, independente do que vem em sx
        borderRadius: '5px !important',
        padding: theme.spacing(1, 2.5),
        fontSize: '0.875rem',
        minHeight: 36,
        ...sx,
      }}
      {...props}
    >
      {children}
    </StyledStandardButton>
  );
};

StandardButton.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['text', 'outlined', 'contained']),
  color: PropTypes.oneOf(['inherit', 'primary', 'secondary', 'success', 'error', 'info', 'warning']),
  size: PropTypes.oneOf(['small', 'medium', 'large']), // Ignorado - sempre usa padrão
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  sx: PropTypes.object
};

export default StandardButton;